import { MediaQueryStyleSheet } from 'react-native-responsive';
import { PALETTE } from '../../../constants';

export default MediaQueryStyleSheet.create(
  {
    mainWrapper: {
      flex: 1,
    },
    content: {
      paddingHorizontal: 40,
      paddingBottom: 40,
      display: 'inline-block',
    },
    inputFields: {
      flex: 1,
    },
    label: {
      paddingTop: 10,
    },
    username: {
      minHeight: 50,
    },
    email: {
      minHeight: 50,
    },
    submitButton: {
      marginTop: 30,
    },
    forgotPasswordPrompt: {
      flex: 1,
    },
    attemptCount: {
      flex: 1,
      flexDirection: 'column',
      alignItems: 'center',
      paddingTop: 30,
    },
    errorTextColor: {
      color: 'red',
    },
    copyrightDisclaimer: {
      textAlign: 'center',
      fontSize: 8,
      color: PALETTE.loginPrimary,
      paddingBottom: 10,
    },
  }
);
